import GraphqlError from '~/components/GraphqlError';
import wrapError from '~/components/JavascriptError/JavascriptErrorHandler';
import LoadingArea from '~/components/LoadingArea';
import MissingPage from '~/components/MissingPage';
import { useCompaniesDomainLookupQuery } from '~/generated/graphql';

import CompanyDrawerDetails from '../Show/CompaniesDrawerDetails';

type CompanyFromDomainProps = {
  domain: string;
};

const CompanyFromDomain = ({ domain }: CompanyFromDomainProps) => {
  const { data, loading, error, refetch } = useCompaniesDomainLookupQuery({
    variables: { companiesSearchQuery: domain },
  });

  if (error) {
    return (
      <div className="x-sidebar">
        <GraphqlError error={error} refetch={refetch} />;
      </div>
    );
  }

  if (loading) {
    return <LoadingArea className="x-sidebar" loading />;
  }

  if (!data?.companies?.edges?.[0]?.node?.id) {
    return <MissingPage className="x-sidebar" />;
  }

  return (
    <CompanyDrawerDetails
      hideProspectorPreview
      id={data.companies.edges[0].node.id}
    />
  );
};

export default wrapError(CompanyFromDomain);
